import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useUserStore } from '../../../store';
import PerformanceSubTab from './PerformanceSubTab';
import WorkTimeSubTab from './WorkTimeSubTab';

function EmployeesTab({ t, dateParams }) {
  const { currentOrganization } = useUserStore();
  const showWorkTime = currentOrganization?.work_hours_reporting_enabled;

  const [searchParams, setSearchParams] = useSearchParams();
  const [subTab, setSubTab] = useState(() => {
    return searchParams.get('subtab') === 'worktime' && showWorkTime ? 1 : 0;
  });

  useEffect(() => {
    const subtabParam = searchParams.get('subtab');
    const newSubTab = subtabParam === 'worktime' && showWorkTime ? 1 : 0;
    if (newSubTab !== subTab) {
      setSubTab(newSubTab);
    }
  }, [searchParams, showWorkTime]);

  const handleSubTabChange = (e, newValue) => {
    setSubTab(newValue);
    const newParams = { tab: 'employees' };
    if (newValue === 1) {
      newParams.subtab = 'worktime';
    }
    setSearchParams(newParams, { replace: true });
  };

  return (
    <Box>
      {showWorkTime && (
        <Box sx={{ mb: 2 }}>
          <Tabs
            value={subTab}
            onChange={handleSubTabChange}
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 'auto',
                px: 2,
              },
            }}
          >
            <Tab label={t('reports.employees.performance')} />
            <Tab label={t('reports.employees.workTimeTab')} />
          </Tabs>
        </Box>
      )}

      {subTab === 0 ? (
        <PerformanceSubTab dateParams={dateParams} />
      ) : (
        <WorkTimeSubTab dateParams={dateParams} />
      )}
    </Box>
  );
}

export default withTranslation()(EmployeesTab);
